import React from 'react'
import 'react-multi-carousel/lib/styles.css';
import video from '../photo_video/1.mp4'


function Online() {
    return (
        <>
            <div className='m-4'>
                <div className='d-flex justify-content-start'>
                    <div className='mb-5 position-relative'><h2 className='pageHeader'>What will you get here ?</h2></div>
                </div>
                <div>
                    <h4> Hello,</h4>

                    <p> I'm <span className='color-red'><b> hepi Gadhesariya </b></span>,wellness coach for a global nutrition and weight management community.</p>

                    <p>Obesity is associated with many lifestyle diseases. Want to free from obesity? Our mission is to make India healthy and fit.</p>

                    <p> We give the solution about </p>
                    <ul className='list-unstyled'>
                        <li>
                            ➡ Lose weight and look great
                        </li>
                        <li>
                            ➡ Gain weight and build muscles

                        </li>
                        <li>
                            ➡ Maintain weight

                        </li>
                        <li>
                            ➡ Improve your digestion

                        </li>
                        <li>
                            ➡ Improve your bones

                        </li>
                        <li>
                            ➡ improve skin and look younger

                        </li>
                        <li>
                            ➡ Improve your energy

                        </li>
                        <li>
                            ➡ Healthy heart and joints

                        </li>
                        <li>
                            ➡ Nutritious protein drink for children

                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <div className='m-3 mt-3 position-relative'><h1>Our Facilities : </h1></div>
            </div>
            <div className='OnlineCub' id="onlineclub">
                <div className='container d-flex justify-content-start flex-column align-items-center mb-4 h-100'>
                    <div>
                        <div className='mb-3 mt-3 position-relative'><h2 className='pageHeader'>Online Club</h2></div>
                    </div>
                    <p className='borderLeft mt-3'>Welcome to our Online Health and Wellness Club, a vibrant and inclusive community dedicated to helping you achieve your health and dietary goals. Our club offers a unique and comprehensive approach to diet planning, combining the expertise of skilled coaches with the power of a supportive community, all accessible from the comfort of your own home </p>
                    <p className='borderLeft mt-3'>Say goodbye to generic meal plans. Our coaches create tailored meal plans that reflect your dietary requirements and goals. Whether you're looking to lose weight, build muscle, manage a health condition, or simply improve your overall well-being, our coaches will guide you towards making informed and nutritious food choice </p>
                </div>
                <div className='onlineVideo p-4'>
                    <video muted controls autoPlay loop style={{ height: '400px', borderRadius: '20px', maxWidth: '100%' }}>
                        <source src={video} type="video/mp4" />
                    </video>
                </div>
            </div>
        </>

    )
}

export default Online
